import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2 } from '@angular/core'
import { GlobalMessageType } from '@spartacus/core'
import { FileSaverService } from 'ngx-filesaver'
import { finalize } from 'rxjs/operators'
import { DispenserAgreementService } from '../../../../../../services/agreement/dispenser/dispenser-agreement.service'
import { CustomGlobalMessageService } from '../../../../../../services/shared/custom-global-message/custom-global-message.service'

@Component({
    selector: 'app-new-dispenser-credit-request',
    templateUrl: './new-dispenser-credit-request.component.html',
    styleUrls: ['./new-dispenser-credit-request.component.scss'],
    standalone: false
})
export class NewDispenserCreditRequestComponent implements OnInit {
  public downloadSpinner = false
  public uploadSpinner = false
  public fileInputControl: any
  public showSuccessMessage = false

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private fileSaverService: FileSaverService,
    public globalMessageService: CustomGlobalMessageService,
    private dispenserAgreementService: DispenserAgreementService,
    private hostElement: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    const page = this.hostElement.nativeElement?.parentElement?.parentElement
    if (page) {
      this.renderer.setStyle(page, 'position', 'relative')
    }
  }

  public onDownloadFormClick(): void {
    this.downloadSpinner = true
    const fileType = '.csv'
    const fileName = 'Dispenser Credit Request Form' + fileType
    this.dispenserAgreementService
      .downloadCreditRequestForm()
      .pipe(
        finalize(() => {
          this.downloadSpinner = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        (res) => {
          this.fileSaverService.save(res.body, fileName)
        },
        (err) => {
          this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
  }

  public onUploadClaimForm(fileList: FileList): void {
    if (!fileList || !fileList.length) {
      this.fileInputControl = null
      return
    }

    const fileType = fileList[0].type
    if (fileType === 'text/csv') {
      this.uploadSpinner = true
      this.dispenserAgreementService
        .uploadCreditRequestForm(fileList)
        .pipe(
          finalize(() => {
            this.uploadSpinner = false
            this.fileInputControl = null
            this.changeDetectorRef.detectChanges()
          })
        )
        .subscribe(
          () => {
            this.showSuccessMessage = true
          },
          (error) => {
            const msg = error.message?.replace(/,/g, '\n')
            this.globalMessageService.add(msg, GlobalMessageType.MSG_TYPE_ERROR)
          }
        )
    } else {
      this.globalMessageService.add(
        { key: 'dispenserAgreement.newClaim.uploadFailed' },
        GlobalMessageType.MSG_TYPE_ERROR
      )
    }
  }
}
